import request from '../../axios/axiosconfig'

/**
 * 登录
 * @param {data}
 * @returns
 */
export function login(data) {
  return request({
    url: '/ps/user/login',
    method: 'post',
    data: data
  })
}

/**
 *
 * @returns 退出登录
 */
export function logout(){
  return request({
    url: '/ps/user/logout',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/sys/login.js